import { useMutation } from "@tanstack/react-query";

import { useApiClient } from "@/context/api-client";

interface UpdateBookedMeetingNotesParamsI {
  campaignId: string;
  accountId: string;
  activityLogId: string;
  notes: string;
}

// GLE-8421: attaches the SDR's notes to the synced lookalike meeting by id.
export const useMutationUpdateBookedMeetingNotes = () => {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: ({
      campaignId,
      accountId,
      activityLogId,
      notes,
    }: UpdateBookedMeetingNotesParamsI) =>
      apiClient.scheduling.updateBookedMeetingNotes(
        campaignId,
        accountId,
        activityLogId,
        { notes }
      ),
  });
};
